import React from "react";
import PropTypes from "prop-types";

function Notification({ message, type }) {
  return (
    <div
      style={{
        backgroundColor: type === "success" ? "#23d160" : "#ff3860",
        padding: "1.25rem",
        position: "fixed",
        bottom: "2vmin",
        left: "2vmin",
        width: 200,
        zIndex: 9999,
        borderRadius: 4,
        boxShadow: "1px 1px 1px rgba(0, 0, 0, 0.25)",
        textAlign: "left",
        color: type === "success" ? "white" : "black",
        cursor: "pointer",
      }}
    >
      {message}
    </div>
  );
}

Notification.propTypes = {
  message: PropTypes.string,
  type: PropTypes.oneOf(["success", "danger"]),
};

Notification.defaultProps = {
  message: "",
  type: "success",
};
export default Notification;
